"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = exports.TypographyVariantToClassName = exports.TypographyVariant = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_module_css_1 = __importDefault(require("./Typography.module.css"));
var TypographyVariant;
(function (TypographyVariant) {
    TypographyVariant["Title1"] = "Title1";
    TypographyVariant["Title2"] = "Title2";
    TypographyVariant["Title3"] = "Title3";
    TypographyVariant["Title4"] = "Title4";
    TypographyVariant["Headline"] = "Headline";
    TypographyVariant["Body"] = "Body";
    TypographyVariant["BodyEmphasis"] = "BodyEmphasis";
    TypographyVariant["Subheadline"] = "Subheadline";
    TypographyVariant["SubheadlineEmphasis"] = "SubheadlineEmphasis";
    TypographyVariant["Caption"] = "Caption";
    TypographyVariant["CaptionEmphasis"] = "CaptionEmphasis";
})(TypographyVariant = exports.TypographyVariant || (exports.TypographyVariant = {}));
/**
 * Generic Typography classes used for basic non-semantic typography
 * Based on the new typography style system: https://zeroheight.com/0cb86e1d3/v/latest/p/441b99-typography/b/44915a/i/132127656
 */
exports.TypographyVariantToClassName = {
    [TypographyVariant.Title1]: Typography_module_css_1.default.title1,
    [TypographyVariant.Title2]: Typography_module_css_1.default.title2,
    [TypographyVariant.Title3]: Typography_module_css_1.default.title3,
    [TypographyVariant.Title4]: Typography_module_css_1.default.title4,
    [TypographyVariant.Headline]: Typography_module_css_1.default.headline,
    [TypographyVariant.Body]: Typography_module_css_1.default.body,
    [TypographyVariant.BodyEmphasis]: Typography_module_css_1.default.bodyEmphasis,
    [TypographyVariant.Subheadline]: Typography_module_css_1.default.subHeadline,
    [TypographyVariant.SubheadlineEmphasis]: Typography_module_css_1.default.subHeadingLineEmphasis,
    [TypographyVariant.Caption]: Typography_module_css_1.default.caption,
    [TypographyVariant.CaptionEmphasis]: Typography_module_css_1.default.captionEmphasis,
};
/**
 * Generic Typography component used for basic non-semantic typography
 * Based on the new typography style system: https://zeroheight.com/0cb86e1d3/v/latest/p/441b99-typography/b/44915a/i/132127656
 */
function Typography({ as: Tag = "span", variant, children }) {
    return (0, jsx_runtime_1.jsx)(Tag, { className: exports.TypographyVariantToClassName[variant], children: children });
}
exports.Typography = Typography;
//# sourceMappingURL=index.js.map